import axios from 'axios'
import store from "../store/store"
import router from "../router/index"
import errorHandler from '../helpers/errorHandler'

export default function execute() {
  // Add a request interceptor
  axios.interceptors.request.use(function(config) {
    if(config.url.includes("get_shipping_price")) {
      // Ignore to run in background as it takes a while
    } else {
      store.commit('setLoading', true)
    }

    const token = store.getters.getToken
    if(token || token !== '') {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['Content-Type'] = `application/json`;
      config.headers['Accept-Language'] = `pt-br`;
    }

    return config;
  })

  // Add a response interceptor
  axios.interceptors.response.use(function (response) {
    store.commit('setLoading', false)
    return response;
  }, function (error) {
    store.commit('setLoading', false)
    if (500 === error.response.status) {
      alert("Um erro foi encontrado")
    }
    if (401 === error.response.status || 404 === error.response.status) {
      store.commit('setToken', '')
      router.push({name: 'login'})
    }
    if (400 === error.response.status){
      let error_return = errorHandler(error.response.data)
      return Promise.reject(error_return);
    }
  });
}
